// src/pages/dashboard/cms/Privacy.jsx
import React from "react";
import { useSelector } from "react-redux";
import CmsPage from "../../../components/common/CmsPage";

export default function Privacy() {
  const { user } = useSelector((state) => state.merchant);

  // Prevent crashing if user not loaded
  const role = user?.role || "user";

  const pageKey =
    role === "merchant"
      ? "privacy_policy_merchant"
      : "privacy_policy_user";

  return <CmsPage pageKey={pageKey} title="Privacy Policy" />;
}
